import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { ProfileUser } from '../../authentication/index';
import { CommonConstants } from '../../core/common.constants';
import { Addworker, UpdateWorkerInformation, ReportTimeWork, UpdateReportTimeWork, AgreementCreateObj, AgreementData } from '../seller';
import { CognitoUtil } from '../../authentication/service/cognito.service';
import { GlobalEventsManager } from '../../app-global-events-manager';
import { AuthService } from '../../authentication/service/auth.service';
import * as moment from 'moment';


@Injectable()
export class SellerApiService {

  // API Link
  public static _BACKEND_API_LINK = environment.backendapi;
  public static _FRONTEND_LINK = environment.frontendlink;
  headers: Headers;
  headersAuth: Headers;
  options: RequestOptions;
  optionsAuth: RequestOptions;
  public accesstoken: any;
  public tokenid: any;
  public self;
  // Constructor Define --- header's Option in constructor
  constructor(public router: Router, private http: Http, public cognito: CognitoUtil,
    private globalEventsManager: GlobalEventsManager, private authservice: AuthService) {
    this.headers = new Headers({ 'Content-Type': 'application/json' });
    this.options = new RequestOptions({ headers: this.headers });
    this.self = this;
  }

  //#region Start Authentication Header Options
  getAuthenticationOtions() {
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    console.log(this.accesstoken);
    console.log(this.tokenid);
    if (!this.accesstoken.__zone_symbol__value) {
      this.authservice.logout();
      this.globalEventsManager.showNavBarSeller(false);
      this.globalEventsManager.showNavBarWorker(false);
      this.globalEventsManager.showNavBar(false);
      this.router.navigate(['/login']);
      return;
    }
    if (!this.authservice.isValidToken(this.accesstoken.__zone_symbol__value)) {
      this.cognito.refresh();
      this.accesstoken = this.cognito.getAccessToken();
      this.tokenid = this.cognito.getIdToken();
    }

    this.headersAuth = new Headers({ 'Content-Type': 'application/json' });
    this.headersAuth.append('token', this.accesstoken.__zone_symbol__value);
    this.headersAuth.append('kid', this.tokenid.__zone_symbol__value);
    this.optionsAuth = new RequestOptions({ headers: this.headersAuth });
    console.log(this.optionsAuth);
    return this.optionsAuth;

  }

   // Cognito End Point check for autharization....
  getValidateEndPoint() {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/validate_cognito_token', {}, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  //#endregion End Athuentications

  //#region  Profile

  /** Profile Page ************************ Start  */
  // get the Profile Details.
  getallNotificationDetails(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_safety_box_notification/' + username, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }


  // get Business Information
  getBussinessDetailInfomation(bussinessid: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/get_quick_facts/' + bussinessid, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get the Profile Details.
  getProfileDetails(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_profile/' + username, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // get the Profile Details...
  updateProfile(profile: ProfileUser): Observable<any> {
    return this.http.put(SellerApiService._BACKEND_API_LINK + '/update_profile', {
      'username': profile.username,
      'first_name': profile.first_name,
      'last_name': profile.last_name,
      'company_name': profile.company_name,
      'address': profile.address,
      'contact_no': profile.contact_no,
      'website': profile.website,
      'seller_email': profile.seller_email,
      'summary': profile.summary
    }, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // Remove Seller Profile Pic
  removeSellerProfilePic(username) {
    return this.http.delete(SellerApiService._BACKEND_API_LINK + '/delete_seller_profile_picture/' + username,
      this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // Get File Upload
  upload_image(file: any, username: string): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let formData: FormData = new FormData();
    formData.append('file', file[0]);
    formData.append('username', username);
    // tslint:disable-next-line:prefer-const
    let headers = new Headers();
    /** No need to include Content-Type in Angular 4 */
    // headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    headers.append('token', this.accesstoken.__zone_symbol__value);
    headers.append('kid', this.tokenid.__zone_symbol__value);
    // tslint:disable-next-line:prefer-const
    let options = new RequestOptions({ headers: headers });
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/upload_image', formData, options)
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // upload worker images
  upload_worker_images(file: any, username: string): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('username', username);
    // tslint:disable-next-line:prefer-const
    let headers = new Headers();
    /** No need to include Content-Type in Angular 4 */
    // headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    headers.append('token', this.accesstoken.__zone_symbol__value);
    headers.append('kid', this.tokenid.__zone_symbol__value);
    // tslint:disable-next-line:prefer-const
    let options = new RequestOptions({ headers: headers });
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/upload_work_image', formData, options)
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get Previous workers images
  getPreviousWorkImages(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_previous_work_images/' + username, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get Show Profile Summary
  getProfileSummary(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_seller_summary/' + username, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get the Profile Details...
  updateProfileSummary(username: string, summary: string): Observable<any> {
    console.log("Updating summary: " + username + " - " + summary);
    return this.http.put(SellerApiService._BACKEND_API_LINK + '/update_seller_summary', {
      'username': username,
      'summary': summary
    },  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Delete Image By Calling worker_image_id in Overview Page
  deleteworkerimagebyimageid(username: string, work_image_id: number): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.delete(SellerApiService._BACKEND_API_LINK + '/delete_previous_work_images/' + username + '/' + work_image_id, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get the list of review username
  getReviewListBySellerUsername(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_project_reviews_for_seller/'
      + username, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // Time Report update worker's
  updateTimeReportOnOffMethod(body) {
    console.log(body);
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/time_report_on_off_for_multiple_workers',
    body, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // get Certificate Types
  getCertificateTypes(seller_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_certificate_types/'
      + seller_id, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // get Certificate Types
  getCertificates(seller_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_certificates/'
      + seller_id, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

   // Add certificates
  addCertificates(body, file) {
    // tslint:disable-next-line:prefer-const
    let formData: FormData = new FormData();
    if (file != null) {
      formData.append('file', file, file.fileName);
    }
    formData.append('modal', JSON.stringify(body));
    // tslint:disable-next-line:prefer-const
    let headers = new Headers();
    /** No need to include Content-Type in Angular 4 */
    // headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    headers.append('token', this.accesstoken.__zone_symbol__value);
    headers.append('kid', this.tokenid.__zone_symbol__value);
    // tslint:disable-next-line:prefer-const
    let options = new RequestOptions({ headers: headers });
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/add_certificate', formData, options)
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // delete the certificate
  deleteCertificate(certificate_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/delete_seller_certificate/'
      + certificate_id, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // get the setting data
  getSettingDatabyUsername(username): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_settings_data/'
    + username, this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this);
    });
  }

  // getting Price Information
  getCurrentStripeInformation(body) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/retrieve_stripe_data', body, this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this);
    });
  }


  // add service area on/Off
  getServiceAreaOnOff(sellerid, is_service_area_enabled, service_area_quantity): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/service_area_on_off/'
    + sellerid + '/' + is_service_area_enabled + '/' + service_area_quantity, this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this);
    });
  }

  // get the Service Area Count
  getServiceAreaCount(username): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/enabled_service_area_count_for_seller/'
    + username , this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this);
    });
  }

  // Update the token for seller
  updatetokenBySellerId(body) {
    console.log(body);
    console.log(SellerApiService._BACKEND_API_LINK + '/add_payment_method_via_settings');
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/add_payment_method_via_settings', body, this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this);
    });
  }

  // get the Pricing List
  getPricingListForSetting(): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_additional_service_fees', this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this);
    });
  }

  // get the Worker List
  getWorkerListForTimeReporting(seller_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_workers_with_project_lead_for_seller/' + seller_id,
    this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this);
    });
  }

  // get the workers list ==> already selected
  getWorkerListSelectedTimeReport(seller_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_time_reporting_enabled_users_for_seller/' + seller_id,
    this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this);
    });
  }

  // Switch the Accounr to
  changeSwitchtoInvoiceFromCard(sellerid): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/switch_to_invoice_from_card/' + sellerid,
      this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // CRM Integration Update Add Time reporting---
  AddCrmTimeReporting(sellerid, quantity): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/seller_add_time_report_for_crm/' + sellerid + '/' + quantity,
      this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

   // CRM Integration Update Remove Time Reporting---
   RemoveCrmTimeReporting(sellerid, quantity): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/seller_remove_time_report_for_crm/' + sellerid + '/' + quantity,
      this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

   // CRM Integration Update Add Time reporting---
   AddCrmExtraServiceArea(sellerid, quantity): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/seller_add_service_area_for_crm/' + sellerid + '/' + quantity,
      this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

   // CRM Integration Update Remove Time Reporting---
   RemoveCrmExtraServiceArea(sellerid, quantity): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/seller_remove_service_area_for_crm/' + sellerid + '/' + quantity,
      this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }




  /** Profile Page ************************ End  */

  //#endregion

  /** Safety Box ************************ Start  */

  // Browse request remove waiting list
  removeFromWaitingListAfterAdded(username, project_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/remove_seller_from_waiting_list/' +
      username + '/' + project_id, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }
  // get Project Information qa  Service Request details
  getServiceRequestDetailsByProjectId(project_id, user_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_service_request_details/' + project_id + '/' + user_id,
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

    // Update Project Information by Service Request details
  update_serviceRequestBySeller(body: any, file): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let formData: FormData = new FormData();
    for (let i = 0; i < file.length; i++) {
      formData.append('file', file[i], file[i].name);
    }
    // formData.append('file', file);
    formData.append('modal', JSON.stringify(body));
    // tslint:disable-next-line:prefer-const
    let headers = new Headers();
    /** No need to include Content-Type in Angular 4 */
    // headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    headers.append('token', this.accesstoken.__zone_symbol__value);
    headers.append('kid', this.tokenid.__zone_symbol__value);
    // tslint:disable-next-line:prefer-const
    let options = new RequestOptions({ headers: headers });

    return this.http.post(SellerApiService._BACKEND_API_LINK + '/update_service_request', formData,
    options).map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this);
      });
  }


  // Get All new Projects By username || Open Request
  getnewallProjects(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_all_new_projects/' + username,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getAllRequestMeProjects(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_service_requests_sent_to_me/' + username,
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }


  // Get All show_agreed_projects
  getAllAgreedProjects(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_agreed_projects/' + username,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }
  // Get all request accepted
  getacceptedProjects(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_accepted_project_requests/' + username, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get Project Information by Project Id
  getProjectInformationByProjectId(projectid: string, sellerid): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_project_information/' + projectid
    + '/' + sellerid,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getProjectInformationByProjectIdandSeller(projectid: string, seller_username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK +
      '/show_project_information_with_service_map/' + projectid + '/' + seller_username,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Browse Request
  getsellerClickFirstSeenProject(seller_id: number, project_id: number, safety_box_link: string): Observable<any> {
    const body = {
      seller_id: seller_id,
      project_id: project_id,
      safety_box_link: safety_box_link
    };
    return this.http.post(SellerApiService._BACKEND_API_LINK +
      '/get_seller_click_on_new_project', body,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get Buyer Information By Buyer Id
  getBuyerInformationByBuyerId(buyer_id: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_buyer_information/' + buyer_id,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get the Archeive Project list and Completed Projects
  getArchiveProjectList(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_archive_list/' + username,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // save uploaded file data under activity files
  // saveToActivityFiles(projectId: number, activityType: string, fileUrl: string, fileType: string): Observable<any> {
  //   let data = { project_id: projectId, activity_type: activityType, file: fileUrl, file_type: fileType };
  //   debugger;
  //   return this.http.post(SellerApiService._BACKEND_API_LINK + '/upload_activity_files/', data, this.options)
  //     .map(this.extractRequests)
  //     .catch(this.handleError);
  // }

  // get uploaded files (during messages)
  getFiles(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_activity_files/' + username,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  acceptRejectProjectRequest(username: string, projectid: Number, is_acceped: boolean, safety_box_link: string,
    service_request_link: string) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/accept_reject_project_request',
      {
        'username': username, 'project_id': projectid, 'is_accepted': is_acceped,
        'service_request_link': service_request_link, 'safety_box_link': safety_box_link
      }, this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // messaging - get file uploading url before actually uploading to s3 bucket
  getFileUrl(fileName: string, projectId: number): Observable<string> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/get_file_url/' + fileName + '/' + projectId + '/1',
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }


  // messaging - uploading attached file into s3 bucket
  uploadAttachedFile(file: any, projectId: number, seller_id: number, fileType: string, activityType: string,
    is_from_chat: boolean): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('activity_type', activityType);
    formData.append('project_id', projectId.toString());
    formData.append('uploaded_user_id', seller_id.toString());
    formData.append('file_type', this.getFileTypeByAdding(fileType));
    formData.append('is_from_chat', is_from_chat.toString());

    // tslint:disable-next-line:prefer-const
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    headers.append('token', this.accesstoken.__zone_symbol__value);
    headers.append('kid', this.tokenid.__zone_symbol__value);
    // tslint:disable-next-line:prefer-const
    let options = new RequestOptions({ headers: headers });

    return this.http.post(SellerApiService._BACKEND_API_LINK + '/upload_activity_files', formData, options)
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get the Profile picture.
  getProfilePicture(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_profile_picture/' + username,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // files - get activity files (files attached during chat)
  // getActivityFiles(projectId: number, seller_id: number, activity_type: string, fileType: string, startNo: number, qty: number) {
  //   return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_activity_files/1/' + projectId + '/' + seller_id + '/'
  //     + activity_type + '/' + fileType + '/' + startNo + '/' + qty,  this.getAuthenticationOtions())
  //     .map(this.extractRequests)
  //     .catch(error => {
  //       return this.customErrorHandle(error, this); });
  // }

  getActivityFiles(projectId: number, seller_id: number, activity_type: string, fileType: string, startNo: number, qty: number) {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_activity_files_for_seller/1/' + projectId + '/' + seller_id + '/'
      + activity_type + '/' + fileType + '/' + startNo + '/' + qty,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }



  // files - count for types
  // getActivityFilesCount(project_id: number, seller_id: number, activity_type: string) {
  //   return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_activity_file_all_count/' + project_id + '/' + seller_id + '/'
  //     + activity_type,  this.getAuthenticationOtions())
  //     .map(this.extractRequests)
  //     .catch(error => {
  //       return this.customErrorHandle(error, this); });
  // }

  getActivityFilesCount(project_id: number, seller_id: number, activity_type: string) {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/get_activity_file_all_count/' + project_id + '/' + seller_id + '/'
      + activity_type,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }


  // files - get activity files (files attached during chat)
  getActivityInternalFiles(projectId: number, seller_id: number, fileType: string, startNo: number, qty: number) {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_activity_files/1/' + projectId + '/' + seller_id + '/'
      + CommonConstants.ACTIVITY_TYPE_INTERNAL + '/' + fileType + '/' + startNo + '/' + qty,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }


  // delete activity files
  deleteFiles(listToDelete: any[]) {
    // tslint:disable-next-line:prefer-const
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    // tslint:disable-next-line:prefer-const
    let options = new RequestOptions({ headers: headers });
    // tslint:disable-next-line:max-line-length
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/delete_activity_files', { 'safety_box_file_ids': listToDelete },
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get activity file as blob by file url
  getFileAsBlob(fileUrl: string): Observable<Blob> {
    return this.http.get(fileUrl, { responseType: ResponseContentType.Blob })
      .map((response) => {
        return response['_body'];
      }) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get Infomration show_internal_project_summary
  getInformationInternallyCreatedProject(project_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_internal_project_summary/' + project_id ,
    this.getAuthenticationOtions())
    .map(this.extractRequests)
    .catch(error => {
      return this.customErrorHandle(error, this); });
  }

  // get the notification after archive the project list
  get_project_Archive_Notification(sellerid): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/seller_get_project_archive_notification/' + sellerid,
      this.getAuthenticationOtions())
      .map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // update the read archive list by Buyer
  public updateProjectArchiveNotificationstatus(projectids): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let body = { project_id_list: projectids };
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/seller_update_project_archive_notification_status', body,
      this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  /** Safety Box ************************ End  */




  /** Manage Project ************************ Start  */

  getUnAssignProjectsByWorkerId(workerid: number): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/get_unassigned_projects_by_worker_id/' + workerid,
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getUnAssignWorkersByprojectId(projectid: number): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/get_unassigned_workers_by_project_id/' + projectid,
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getWorkersByprojectId(projectid: number): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_workers/' + projectid,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getShowWorkersBySellerId(sellerid: number): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_all_workers/' + sellerid,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getWorkerInformation(worker_id: number): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_worker_information/' + worker_id,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }
  // Check email exist or not
  public checkUserNameExitsOrNot(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/email_exist/' + username,  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });

  }

  addworkerstoProject(addworker: Addworker) {
    addworker.registration_url = SellerApiService._FRONTEND_LINK + '/worker/registration';
    console.log(addworker);
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/add_worker',
      addworker,  this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Resend Invitation to worker Email
  resendinvitationto_worker(email) {
    const body = {
      worker_email: email,
      registration_url: SellerApiService._FRONTEND_LINK + '/worker/registration'
    };
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/resend_worker_invitation',
      body, this.getAuthenticationOtions()).map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  updateworkerstoProject(updatewokrer: UpdateWorkerInformation) {
    return this.http.put(SellerApiService._BACKEND_API_LINK + '/edit_worker_information',
      updatewokrer,  this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  assignWorkertoProject(assignworker: any) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/assign_worker',
      assignworker,  this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getWorkerTypeDetails(): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_worker_types',  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  reporttimeByProjectId(reporttime: UpdateReportTimeWork) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/report_time',
      reporttime,  this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get the time sheets by project Id and range Date
  getshowtimesheetsByProject(project_id: number, startdate: string, enddate: string): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_time_sheets_for_web/' + project_id + '/' + startdate + '/' + enddate,
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get the time sheets by User Id and range Date
  getshowtimesheetsByUserId(user_id: number, startdate: string, enddate: string): Observable<any> {
    // tslint:disable-next-line:max-line-length
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_time_sheets_for_user_web/' + user_id + '/' + startdate + '/' + enddate,
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get service categories
  getServiceCategories(): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_service_categories/0',  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getExtraServiceCategories(): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_extra_service_categories',  this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Add new Project Manage
  addNewProjectBySeller(addnewproject: any) {
    console.log(addnewproject);
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/add_new_project_from_manage_project',
      addnewproject,  this.getAuthenticationOtions()).map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this); });
  }

  change_is_location_required(modal: any) {
    return this.http.put(SellerApiService._BACKEND_API_LINK + '/change_is_location_required',
      modal,  this.getAuthenticationOtions()).map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this); });
  }


  // Add New Project Details By people
  get_InternalProject_serviceCategory(): Observable<any>  {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_all_service_categories_for_internal_project',
    this.getAuthenticationOtions())
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Validate the Mobile Bank Id
  getValidateBankIdForInternalProject(bankid): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/check_bank_id_exist/' + bankid,
    this.getAuthenticationOtions()).map(this.extractRequests).catch(error => {
      return this.customErrorHandle(error, this); });
  }

  /** Manage Project ************************ End  */

  /** Safety box agreement ************************ Start  */
  // get Identify System Ready to create Offer In the Production
  checkProductionCreateOffer(company_registration_no){
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/check_contract_sign_method/' + company_registration_no,
    this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // send push notification
  sendPushNotification(body) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/send_firebase_chat_push_notification_android',
    body,  this.getAuthenticationOtions()).map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this); });
  }

  sendPushNotification_ios(body) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/send_firebase_chat_push_notification_ios',
    body,  this.getAuthenticationOtions()).map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this); });
  }

  createChangeAgreementPdf(body: any) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/convert_additional_agreement_pdf',
      body, this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }


  createAgreementPdf(body: any) {
    console.log(body);
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/convert_pdf',
      body
      ,  this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get agreement
  getAgreementFilePath(projectid: number, sellerid: number): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/get_agreement_file_path/' + projectid + '/' + sellerid,
    this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get the agreement Information by One Agreemnt Id
  getAgreementInfomrationByagreementId(agreementid: number, is_additional_agreement): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/get_agreement_information/' + agreementid + '/' + is_additional_agreement,
    this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }


  // Upload agreements
  uploadAgreementBySeller(project_id: number,
    seller_id: number,
    buyer_id: number,
    project_start_date: Date,
    project_end_date: Date,
    offer_expiry_date: Date,
    total_price: number, file: any, safety_box_link: string): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let formData: FormData = new FormData();
    formData.append('project_id', project_id.toString());
    formData.append('seller_id', seller_id.toString());
    formData.append('buyer_id', buyer_id.toString());
    formData.append('project_start_date', this.formatDate(project_start_date));
    formData.append('project_end_date', this.formatDate(project_end_date));
    formData.append('offer_expiry_date', this.formatDate(offer_expiry_date));
    formData.append('total_price', total_price.toString());
    formData.append('safety_box_link', safety_box_link.toString());
    formData.append('file', file);
    // tslint:disable-next-line:prefer-const
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    headers.append('token', this.accesstoken.__zone_symbol__value);
    headers.append('kid', this.tokenid.__zone_symbol__value);
    // tslint:disable-next-line:prefer-const
    let options = new RequestOptions({ headers: headers });
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/upload_agreement ', formData, options)
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  uploadagreementbrowsefile(projectid: number, file: any): Observable<any> {
    // tslint:disable-next-line:prefer-const
    let formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('project_id', projectid.toString());
    // tslint:disable-next-line:prefer-const
    let headers = new Headers();
    headers.append('Accept', 'application/json');
    this.accesstoken = this.cognito.getAccessToken();
    this.tokenid = this.cognito.getIdToken();
    headers.append('token', this.accesstoken.__zone_symbol__value);
    headers.append('kid', this.tokenid.__zone_symbol__value);
    // tslint:disable-next-line:prefer-const
    let options = new RequestOptions({ headers: headers });
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/upload_agreement_work_files', formData, options)
      .map(this.extractRequests)
      .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  /** Service Area Map */
  // get all Service Area
  getAllServiceAreasMap(): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_all_service_areas',
    this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Add service array by seller and multiple area
  addServiceAreaMapByUserId(username: string, service_map_ids: any) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/set_seller_service_map',
      { username: username, service_map_ids: service_map_ids }
      ,  this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get service areas by Particular Seller
  getAllServiceAreasMapByUserName(username: string): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_seller_service_map_areas/' + username,
    this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // get service area infomation
  getServiceAreaInformationByserviceareaId(service_map_id: number): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/show_service_map_area_information/' + service_map_id,
    this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }
  // delete service area by username and id
  deleteServiceAreaMapByUserId(username: string, service_map_id: any) {
    return this.http.delete(SellerApiService._BACKEND_API_LINK + '/delete_seller_service_map/' + username + '/' + service_map_id,
    this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get Service Request Part
  getServiceRequestQuestionSetByProjectId(project_id): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/seller_show_service_request_questions_by_project_id/' + project_id,
    this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  getGeneralizedQuestionSet(serviceCategory_id, subCategoryIndex): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/seller_show_service_request_questions/'
      + serviceCategory_id + '/' + subCategoryIndex,
      this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get Other Catgory Work Item By Seller Id
  getOthercategoryWorkerItem(sellerid): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/get_all_work_items_for_seller/' + sellerid ,
      this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Get the Buyers Search Details
  getBuyerDetailsBySellerId(sellerid): Observable<any> {
    return this.http.get(SellerApiService._BACKEND_API_LINK + '/search_buyer/' + sellerid ,
      this.getAuthenticationOtions()).map(this.extractRequests) .catch(error => {
        return this.customErrorHandle(error, this); });
  }

  // Save Internal Project By Adding Details
  saveInternalProjectByManageProjects(files, body) {
    // tslint:disable-next-line:prefer-const
    let formData: FormData = new FormData();
    for (let i = 0; i < files.length; i++) {
      formData.append('file', files[i], files[i].name);
    }
    // formData.append('file', file);
    formData.append('modal', JSON.stringify(body));

     // tslint:disable-next-line:prefer-const
     let headers = new Headers();
     /** No need to include Content-Type in Angular 4 */
     // headers.append('Content-Type', 'multipart/form-data');
     headers.append('Accept', 'application/json');
     this.accesstoken = this.cognito.getAccessToken();
     this.tokenid = this.cognito.getIdToken();
     headers.append('token', this.accesstoken.__zone_symbol__value);
     headers.append('kid', this.tokenid.__zone_symbol__value);
     // tslint:disable-next-line:prefer-const
     let options = new RequestOptions({ headers: headers });

     console.log(formData);
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/create_internal_project', formData, options).
    map(this.extractRequests) .catch(error => {
      return this.customErrorHandle(error, this); });
  }


  //#region  Safety box agreement
  /** Safety box agreement ************************ End  */

  getGenerateBodyPdf(agreementCreateObj: AgreementCreateObj, htmlconent: string, projectid: number,
    sellerid: number, buyer_id: number, is_from_create_offer: boolean, is_from_change_request: boolean, agreementParentId, draft) {
    // tslint:disable-next-line:prefer-const
    let agreeementObj = new AgreementData();
    agreeementObj.total_price = agreementCreateObj.total_price;
    agreeementObj.html_content = htmlconent;
    agreeementObj.project_id = projectid;
    agreeementObj.buyer_id = buyer_id;
    agreeementObj.seller_id = sellerid;
    agreeementObj.project_end_date = this.formatAgreementDate(agreementCreateObj.enddate);
    agreeementObj.project_start_date = this.formatAgreementDate(agreementCreateObj.startdate);
    agreeementObj.offer_expiry_date = this.formatAgreementDate(agreementCreateObj.offerExpirydate);
    if (agreementCreateObj.priceOption1 === 'Fast pris') {
      agreeementObj.is_fixed_price_direct_total = agreementCreateObj.isTotalFastPrice;
      agreeementObj.is_fixed_price = true;
      agreeementObj.is_ongoing_bill = false;
      agreeementObj.is_approximate_price = false;
    }
    if (agreementCreateObj.priceOption2 === 'Ungefärlig prisuppgift') {
      agreeementObj.is_approximate_price = true;
      agreeementObj.is_fixed_price = false;
      agreeementObj.is_ongoing_bill = false;
    }
    if (agreementCreateObj.priceOption3 === 'Löpande räkning​') {
      agreeementObj.is_ongoing_bill = true;
      agreeementObj.is_approximate_price = false;
      agreeementObj.is_fixed_price = false;
    }
    agreeementObj.yosso_fee = agreementCreateObj.yosso_fee;
    agreeementObj.work_cost = agreementCreateObj.fastpriceArbete;
    agreeementObj.material_cost = agreementCreateObj.fastpriceMaterial;
    agreeementObj.travel_cost = agreementCreateObj.fastpriceResor;
    agreeementObj.approximate_cost = agreementCreateObj.ungefarligprisuppgift;
    agreeementObj.work_hourly_cost = agreementCreateObj.lopandeArbete;
    agreeementObj.work_flow_hourly_cost = agreementCreateObj.lopandeArbetsledning;
    agreeementObj.sub_contract_cost_rate = agreementCreateObj.lopandeOverenskomna;
    agreeementObj.other_cost_rate = agreementCreateObj.lopandeMaterial;
    agreeementObj.travel_charge_details = agreementCreateObj.lopandeResorDetails;

    agreeementObj.risk_and_liability = agreementCreateObj.sellercompanyinsurance;
    agreeementObj.uploaded_links = agreementCreateObj.uploaded_links;
    agreeementObj.work_and_materials = agreementCreateObj.buyerworkspecification;
    agreeementObj.work_if_craft_man_declined = agreementCreateObj.buyerworkExecuted;
    agreeementObj.reason_for_rejection = agreementCreateObj.buyerworknotrecommended;
    if (agreementCreateObj.taxdeduction === 'Yes') {
      agreeementObj.is_with_ROT_deduction = true;
    }
    agreeementObj.condominium_designation = agreementCreateObj.propertyId;
    agreeementObj.association_org_no = agreementCreateObj.propertyorgno;
    agreeementObj.ROT_deduction_client = agreementCreateObj.individualtaxdeduction;
    agreeementObj.hourly_rate_for_work = agreementCreateObj.hourlyPriceadditionalwork;
    agreeementObj.hourly_rate_for_work_management = agreementCreateObj.hourlyPriceadditionalworkManage;
    agreeementObj.is_additional_work_pay_on_invoice = agreementCreateObj.paymentOption1;
    agreeementObj.is_entire_payment_done_after_work_done = agreementCreateObj.paymentOption2;
    agreeementObj.is_payment_done_according_to_payment_plan = agreementCreateObj.paymentOption3;
    agreeementObj.is_specified_invoice = agreementCreateObj.paymentOption4;
    // agreeementObj.is_additional_work_pay_on_invoice = agreementCreateObj.paymentOption1;
    agreeementObj.other_agreements = agreementCreateObj.additionalagreement;
    agreeementObj.is_from_create_offer = is_from_create_offer;
    agreeementObj.is_from_change_request = is_from_change_request;
    agreeementObj.parent_agreement_id = agreementParentId;
    agreeementObj.safety_box_link = environment.buyerendlink
    + '/buyer/safetybox?requestto=safetybox&requesttype=activerequest&selectedtab=agreement&sellerid=' +  sellerid
    + '&projectid=';
    agreeementObj.is_draft = draft;
    return agreeementObj;
  }


  getSubCategoryType(categoryId: string): Array<any> {
    let listOfItem: Array<any> = [];
    switch (categoryId) {
      case '1':
        listOfItem = ['Bygga nytt kök från grunden',
        'Delvis renovering av befintligt kök', 'Totalrenovering av befintligt kök'];
        return listOfItem;
      case '2':
        listOfItem = ['Bygga nytt badrum', 'Totalrenovering'];
        return listOfItem;
      case '3':
        listOfItem = ['Lägga nytt golv', 'Golvrenovering'];
        return listOfItem;
      case '4':
        listOfItem = ['Bygga ny vägg', 'Väggrenovering'];
        return listOfItem;
      case '5':
        listOfItem = ['Bygga nytt innertak', 'Renovering av innertak'];
        return listOfItem;
      case '6':
        listOfItem = ['Ny målning', 'Renovering målning inomhus'];
        return listOfItem;
      case '7':
        listOfItem = ['Nyinstallation av el', 'Reparation av el'];
        return listOfItem;
      case '8':
        listOfItem = ['Nyinstallation av VVS', 'Reparation av VVS'];
        return listOfItem;
      case '9':
        listOfItem = ['Nybyggnation', 'Renovering'];
        return listOfItem;
      case '10':
        listOfItem = ['Nyinstallation av fönster / dörrar', 'Renovering av fönster / dörrar'];
        return listOfItem;

    }
    return null;
  }

  getFileTypeByAdding(filetype: string): string {
    switch (filetype.toLowerCase()) {
      case 'image':
        return 'image';
      case 'doc':
        return 'doc';
      case 'pdf':
        return 'doc';
      case 'key':
        return 'doc';
      case 'numbers':
        return 'doc';
      case 'pages':
        return 'doc';
      case 'ppt':
        return 'doc';
      case 'txt':
        return 'other';
      case 'excel':
        return 'doc';
      case 'audio':
        return 'audio';
      case 'video':
        return 'video';
      case 'other':
        return 'other';
      default:
        return 'other';

    }
  }

  getThumbnailImages(filetype: string, fileurl: string): string {
    // determine file type
    switch (filetype.toLowerCase()) {
      case CommonConstants.FILE_TYPE_IMAGE:
        return fileurl;

      case CommonConstants.FILE_TYPE_DOC:
        // tslint:disable-next-line:prefer-const
        let filetypefind = fileurl.split('.').splice(-1)[0].toLocaleLowerCase();
        switch (this.getMainFileType(filetypefind.toLocaleLowerCase())) {
          case CommonConstants.FILE_TYPE_EXCEL:
            return '../assets/images/excel.png';

          case CommonConstants.FILE_TYPE_KEY:
            return '../assets/images/key-icon.png';

          case CommonConstants.FILE_TYPE_NUMBERS:
            return '../assets/images/numbers-icon.png';

          case CommonConstants.FILE_TYPE_PAGES:
            return '../assets/images/pages-icon.png';

          case CommonConstants.FILE_TYPE_PDF:
            return '../assets/images/pdf-icon.png';

          case CommonConstants.FILE_TYPE_PPT:
            return '../assets/images/ppt-icon.png';

          case CommonConstants.FILE_TYPE_TXT:
            return '../assets/images/text-icon.png';
          default:
            return '../assets/images/doc.png';
        }

      case CommonConstants.FILE_TYPE_EXCEL:
        return '../assets/images/excel.png';

      case CommonConstants.FILE_TYPE_KEY:
        return '../assets/images/key-icon.png';

      case CommonConstants.FILE_TYPE_NUMBERS:
        return '../assets/images/numbers-icon.png';

      case CommonConstants.FILE_TYPE_PAGES:
        return '../assets/images/pages-icon.png';

      case CommonConstants.FILE_TYPE_PDF:
        return '../assets/images/pdf-icon.png';

      case CommonConstants.FILE_TYPE_PPT:
        return '../assets/images/ppt-icon.png';

      case CommonConstants.FILE_TYPE_TXT:
        return '../assets/images/text-icon.png';

      case CommonConstants.FILE_TYPE_AUDIO:
        return '../assets/images/audio.png';

      case CommonConstants.FILE_TYPE_VIDEO:
        return '../assets/images/video.png';
      case CommonConstants.FILE_TYPE_OTHER:
        // tslint:disable-next-line:prefer-const
        let filetypefindother = fileurl.split('.').splice(-1)[0].toLocaleLowerCase();
        switch (this.getMainFileType(filetypefindother.toLocaleLowerCase())) {
          case CommonConstants.FILE_TYPE_EXCEL:
            return '../assets/images/excel.png';

          case CommonConstants.FILE_TYPE_KEY:
            return '../assets/images/key-icon.png';

          case CommonConstants.FILE_TYPE_NUMBERS:
            return '../assets/images/numbers-icon.png';

          case CommonConstants.FILE_TYPE_PAGES:
            return '../assets/images/pages-icon.png';

          case CommonConstants.FILE_TYPE_PDF:
            return '../assets/images/pdf-icon.png';

          case CommonConstants.FILE_TYPE_PPT:
            return '../assets/images/ppt-icon.png';

          case CommonConstants.FILE_TYPE_TXT:
            return '../assets/images/text-icon.png';
          default:
            return '../assets/images/doc.png';
        }

      default:
        return '../assets/images/doc.png';
    }
  }


  getMainFileType(extention: string): string {
    switch (extention) {
      case 'docx':
        return 'doc';
      case 'doc':
        return 'doc';
      case 'docm':
        return 'doc';
      case 'dotx':
        return 'doc';
      case 'dotm':
        return 'doc';
      case 'docb':
        return 'doc';
      case 'pdf':
        return 'pdf';
      case 'key':
        return 'key';
      case 'numbers':
        return 'numbers';
      case 'pages':
        return 'pages';
      case 'ppt':
        return 'ppt';
      case 'pot':
        return 'ppt';
      case 'pps':
        return 'ppt';
      case 'pptx':
        return 'ppt';
      case 'pptm':
        return 'ppt';
      case 'potx':
        return 'ppt';
      case 'potm':
        return 'ppt';
      case 'ppam':
        return 'ppt';
      case 'ppsx':
        return 'ppt';
      case 'ppsm':
        return 'ppt';
      case 'sldx':
        return 'ppt';
      case 'sldm':
        return 'ppt';

      case 'txt':
        return 'txt';
      case 'rtf':
        return 'txt';
      case 'tex':
        return 'txt';
      case 'xls':
        return 'excel';

      case 'xlt':
        return 'excel';
      case 'xlm':
        return 'excel';
      case 'xlsx':
        return 'excel';
      case 'xlsm':
        return 'excel';
      case 'xltx':
        return 'excel';
      case 'xltm':
        return 'excel';
      case 'xlsb':
        return 'excel';
      case 'xla':
        return 'excel';
      case 'xlam':
        return 'excel';
      case 'xll':
        return 'excel';
      case 'xlw':
        return 'excel';
      case 'csv':
        return 'excel';

    }
    return null;
  }

  // format the Date
  formatDate(timestamp) {
    if (timestamp != null) {
      // tslint:disable-next-line:prefer-const
      let x = new Date(timestamp);
      // tslint:disable-next-line:prefer-const
      let dd = x.getDate();
      // tslint:disable-next-line:prefer-const
      let mm = x.getMonth() + 1;
      // tslint:disable-next-line:prefer-const
      let yy = x.getFullYear();
      return dd + '/' + mm + '/' + yy;
    } else {
      return '';
    }
  }

  // Write the Date time Format
  formatAgreementDate(timestamp) {
    if (timestamp != null) {
      // tslint:disable-next-line:prefer-const
      let findate = moment(timestamp);
      return new Date(findate.format('YYYY-MM-DD'));
    } else {
      return timestamp;
    }
  }

  //#endregion static methods

  // Project Completed from a request...
  projectCompletedRequest(body) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/complete_project', body,
      this.getAuthenticationOtions()).map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this);
      });
  }

  // Project Cancelled from a request...
  projectCancelledRequest(body) {
    return this.http.post(SellerApiService._BACKEND_API_LINK + '/cancel_project', body,
      this.getAuthenticationOtions()).map(this.extractRequests).catch(error => {
        return this.customErrorHandle(error, this);
      });
  }





  /** Response and Errors Receive ************************ Start  */

  // Response split
 extractRequests(res: Response) {
    if (res['_body']) {
      const data = JSON.parse(res['_body']);
      if (data != null && data.value) { return data.value; }
      // tslint:disable-next-line:one-line
      else { return data; }
    }
  }

  // Error Handler
 handleError(error: Response | any) {
    // check JWT expired error - if expired refresh page, this'll redirect to login automatically by auth guard
    if (error.message === 'No JWT present or has expired') {
      location.reload();
    }

    let errMsg: string;
    if (error instanceof Response) {
      // const body = error.json() || '';
      const err = JSON.stringify(error);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    // console.error(errMsg);
    return Observable.throw(errMsg);
  }

  customErrorHandle(error: Response | any, self) {
    if (error.status === 401) {
      self.globalEventsManager.showNavBarSeller(false);
      self.globalEventsManager.showNavBarWorker(false);
      self.globalEventsManager.showNavBar(false);
      self.router.navigate(['/login']);
      return;
    }
    // check JWT expired error - if expired refresh page, this'll redirect to login automatically by auth guard
    if (error.message === 'No JWT present or has expired') {
      location.reload();
    }

    let errMsg: string;
    if (error instanceof Response) {
      // const body = error.json() || '';
      const err = JSON.stringify(error);
      errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
    } else {
      errMsg = error.message ? error.message : error.toString();
    }
    // console.error(errMsg);
    return Observable.throw(errMsg);
  }
  /** Response and Errors Receive ************************ END  */

}



// WEBPACK FOOTER //
// ./src/app/seller/service/seller-api.service.ts